// extracted by mini-css-extract-plugin
export var aside = "mainNav-module--aside--f1a47";
export var dark = "mainNav-module--dark--38c50";
export var header = "mainNav-module--header--bbdcc";
export var item = "mainNav-module--item--86565";
export var itemActive = "mainNav-module--item-active--322b9";
export var light = "mainNav-module--light--a6393";
export var logo = "mainNav-module--logo--a2109";
export var modalVideo = "mainNav-module--modal-video--101b1";
export var modalVideoBody = "mainNav-module--modal-video-body--1a6e0";
export var modalVideoCloseBtn = "mainNav-module--modal-video-close-btn--b2e5b";
export var modalVideoEffectExit = "mainNav-module--modal-video-effect-exit--67d30";
export var modalVideoInner = "mainNav-module--modal-video-inner--8316b";
export var modalVideoMovieWrap = "mainNav-module--modal-video-movie-wrap--4a980";
export var nav = "mainNav-module--nav--795fd";
export var open = "mainNav-module--open--271b7";
export var shown = "mainNav-module--shown--16bdf";
export var smallNav = "mainNav-module--smallNav--7370d";
export var submenu = "mainNav-module--submenu--3369b";
export var submenuActive = "mainNav-module--submenu-active--ecbb3";
export var submenuList = "mainNav-module--submenuList--c23be";
export var toggle = "mainNav-module--toggle--9df0a";